import tinycolor from 'tinycolor2';

export function getTextColorsFromSection(site, section) {
  const backgroundStyle = section.styles.background;
  const color = (backgroundStyle && backgroundStyle.backgroundColor) || '#FFF';
  return getTextColorsFromColor(site, color);
}

export function getTextColorsFromColor(site, referenceColor) {
  const { styles } = site;
  const light = !referenceColor || tinycolor(referenceColor).isLight();

  const titleDark = (styles && styles.titleColorLightBackground) || '#666';
  const titleLight = (styles && styles.titleColorDarkBackground) || '#FFF';

  const textDark = (styles && styles.textColorLightBackground) || '#666';
  const textLight = (styles && styles.textColorDarkBackground) || '#FFF';

  const title = {
    color: light ? titleDark : titleLight,
  };

  const text = {
    color: light ? textDark : textLight,
  };

  return { title, text };
}



// WEBPACK FOOTER //
// ./src/site-render/src/lib/colors.js